import { Accordion, Col, Form, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

export function DiscussionGroup4({ state, handleChange }) {
	const { t } = useTranslation()
	const path = window.location.pathname
	const isPersonal = path.startsWith('/personal')

	return (
		<Accordion defaultActiveKey={['discussionconfidential-1']} flush alwaysOpen>
			<Accordion.Item key="discussionconfidential-1" eventKey="discussionconfidential-1">
				<Accordion.Header>{t('ConfidentialInfo', 'Luottamukselliset asiat')}</Accordion.Header>
				<Accordion.Body>
					<Row>
						<Form.Group as={Col} xl={10} className="position-relative" controlId="discussionConfidential">
							<Form.Label>{t('ConfidentialInfo', 'Luottamukselliset asiat')}</Form.Label>
							<Form.Control
								as="textarea"
								rows="10"
								defaultValue={state.discussionConfidential}
								onChange={handleChange}
								disabled={isPersonal}
								className="memobackground"
							/>
						</Form.Group>
					</Row>
				</Accordion.Body>
			</Accordion.Item>
		</Accordion>
	)
}
